<template>
  <div class="page page-scroll-container">
    <!-- Debug 信息面板（上线前删除） -->
    <!-- <div class="debug-panel">
      <div class="debug-title" @click="debugVisible = !debugVisible">
        🔍 Debug（点击{{ debugVisible ? "收起" : "展开" }}）
      </div>
      <div v-if="debugVisible" class="debug-content">
        <div><b>content:</b> {{ content || "(空)" }}</div>
        <div><b>localStorage content:</b> {{ debugContent || "(空)" }}</div>
        <div>
          <b>token:</b>
          {{ token ? "有(" + token.slice(0, 10) + "...)" : "(空)" }}
        </div>
        <div><b>signingStatus:</b> {{ signingStatus }}</div>
        <div class="debug-logs">
          <div v-for="(log, i) in debugLogs.slice(-10)" :key="i">{{ log }}</div>
        </div>
      </div>
    </div> -->

    <div class="page-header">
      <div class="title">个人信息</div>
    </div>

    <div v-if="pageLoading" class="loading-wrapper">
      <van-loading size="24px">加载中...</van-loading>
    </div>

    <!-- 详情展示（所有签约状态共用） -->
    <div v-else-if="showDetail" class="signed-info">
      <van-cell-group inset>
        <van-cell title="姓名" :value="form.name" />
        <van-cell title="手机号" :value="form.phone" />
        <van-cell title="微信号" :value="form.wechat || '未填写'" />
        <van-cell title="身份证号" :value="form.certNumber" />
        <!-- <van-cell title="开户行" :value="form.bankName || '未填写'" /> -->
        <van-cell title="银行卡号" :value="form.bankCard || '未填写'" />

        <van-cell title="签约状态" :value="statusText" />
      </van-cell-group>

      <div class="id-card-images">
        <div class="id-card-item">
          <span class="id-card-label">身份证人像面</span>
          <van-image
            v-if="form.idCardFrontPath"
            width="120"
            height="80"
            fit="cover"
            :src="form.idCardFrontPath"
            @click="previewImage(form.idCardFrontPath)"
          />
          <span v-else class="empty-text">未上传</span>
        </div>
        <div class="id-card-item">
          <span class="id-card-label">身份证国徽面</span>
          <van-image
            v-if="form.idCardBackPath"
            width="120"
            height="80"
            fit="cover"
            :src="form.idCardBackPath"
            @click="previewImage(form.idCardBackPath)"
          />
          <span v-else class="empty-text">未上传</span>
        </div>
      </div>

      <!-- 底部提示（根据不同状态显示不同内容） -->
      <div v-if="signingStatus == '1'" class="signed-tip">
        <van-icon name="success" color="#07c160" size="20" />
        <span>您已完成签约，信息仅可查看</span>
      </div>

      <div v-else-if="signingStatus == '2' && !signUrl" class="terminated-tip">
        <van-icon name="warning" color="#ee0a24" size="20" />
        <span>您已解约,信息仅可查看</span>
      </div>

      <div v-else-if="showRedirect" class="redirect-tip-wrapper">
        <van-loading size="20" color="#ee0a24" />
        <span>{{ redirectTip }}</span>
      </div>
    </div>

    <!-- （signingStatus == 0 且 signUrl 无值） -->
    <van-form v-else ref="formRef" @submit="onSubmit">
      <van-cell-group inset>
        <van-field
          v-model="form.name"
          name="name"
          label="姓名"
          placeholder="请填写姓名"
          :required="true"
          :rules="[{ required: true, message: '' }]"
        />
        <van-field
          v-model="form.phone"
          name="phone"
          label="手机号码"
          placeholder="请填写手机号码"
          :required="true"
          :rules="[
            { required: true, message: '' },
            { pattern: /^1\d{10}$/, message: '请输入正确的手机号码' },
          ]"
        />
        <van-field
          v-model="form.verifyCode"
          name="verifyCode"
          label="短信验证码"
          placeholder="请填写验证码"
          :required="true"
          :rules="[{ required: true, message: '' }]"
        >
          <template #button>
            <van-button
              size="small"
              type="primary"
              class="blue-btn"
              :disabled="countdown > 0"
              @click="getVerifyCode"
            >
              {{ countdown > 0 ? countdown + "s" : "获取验证码" }}
            </van-button>
          </template>
        </van-field>
        <van-field
          v-model="form.certNumber"
          name="certNumber"
          label="身份证号码"
          placeholder="请填写身份证号码"
          :required="true"
          :rules="[
            { required: true, message: '' },
            { pattern: /^\d{17}[\dXx]$/, message: '请输入正确的身份证号码' },
          ]"
        />
        <van-field
          v-model="form.wechat"
          label="微信号"
          placeholder="请填写微信号"
        />
        <van-field
          v-model="form.bankCard"
          name="bankCard"
          label="银行卡号"
          placeholder="请填写银行卡号"
          :required="true"
          :rules="[
            { required: true, message: '' },
            { validator: validateBankCard, message: '请输入正确的银行卡号' },
          ]"
        />

        <div class="upload-group">
          <div class="upload-item">
            <div class="upload-inner">
              <span class="upload-label">
                身份证人像面 <span class="required">*</span>
              </span>
              <van-uploader
                v-model="frontFileList"
                :max-count="1"
                accept="image/*"
                @after-read="afterReadFront"
                @delete="deleteFront"
              />
            </div>
            <div class="upload-tip">点击上传人像面</div>
          </div>
          <div class="upload-item">
            <div class="upload-inner">
              <span class="upload-label">
                身份证国徽面 <span class="required">*</span>
              </span>
              <van-uploader
                v-model="backFileList"
                :max-count="1"
                accept="image/*"
                @after-read="afterReadBack"
                @delete="deleteBack"
              />
            </div>
            <div class="upload-tip">点击上传国徽面</div>
          </div>
        </div>

        <div class="contract-wrapper">
          <div class="contract-text">
            已阅读并同意
            <span class="protocol-link" @click="showProtocol = true">
              《灵活就业服务协议》
            </span>
          </div>
        </div>
      </van-cell-group>

      <div class="submit-wrapper">
        <van-button
          round
          block
          type="primary"
          class="blue-btn"
          native-type="submit"
          :loading="submitting"
        >
          签约
        </van-button>
      </div>
    </van-form>

    <protocol-popup v-model="showProtocol" />
  </div>
</template>

<script>
import { Toast } from "vant";
import ProtocolPopup from "@/components/ProtocolPopup.vue";
import { httpPost, httpPostForm, httpGetQuery } from "@/utils/fetch";
import { getStorage, setStorage } from "@/utils/storage";
import { getContentFromState } from "@/utils/wechatAuth";

export default {
  name: "MyInfo",
  components: { ProtocolPopup },
  data() {
    return {
      debugVisible: true,
      debugLogs: [],
      debugContent: "",
      content: "",
      pageLoading: true,

      signingStatus: -1, // 0=未签约 1=已签约 2=解约
      signUrl: null,

      // 页面状态
      showRedirect: false,
      redirectTip: "",

      token: "",

      form: {
        name: "",
        bankName: "",
        bankCard: "",
        wechat: "",
        phone: "",
        verifyCode: "",
        certNumber: "",
        idCardFront: null,
        idCardBack: null,
        idCardFrontPath: "",
        idCardBackPath: "",
      },
      frontFileList: [],
      backFileList: [],
      countdown: 0,
      countdownTimer: null,
      submitting: false,
      showProtocol: false,
      isSignCallback: false,
    };
  },
  computed: {
    //  是否展示详情（
    showDetail() {
      return (
        this.signingStatus == "1" ||
        this.signingStatus == "2" ||
        (this.signingStatus == "0" && this.signUrl)
      );
    },
    //  状态文字
    statusText() {
      if (this.signingStatus == "0") return "未签约";
      if (this.signingStatus == "1") return "已签约";
      if (this.signingStatus == "2") return "已解约";
      return "未知";
    },
  },
  mounted() {
    // 1. 获取 content（优先 URL content，其次 state，再次入口缓存）
    this.content = this.resolveContent();
    this.debugContent = this.content;

    if (!this.content) {
      Toast.fail("页面信息缺失，请重新扫码进入");
      this.pageLoading = false;
      return;
    }
    setStorage("wechat_content", this.content);

    // 2. 获取 token（路由守卫已存好）
    const localToken = getStorage("wechat_token");
    if (!localToken) {
      Toast.fail("授权失败，请刷新页面重试");
      this.pageLoading = false;
      return;
    }
    this.token = localToken;

    // 3. 拉取用户信息
    this.fetchUserInfo();
  },

  methods: {
    addLog(msg) {
      const time = new Date().toLocaleTimeString();
      this.debugLogs.push(`[${time}] ${msg}`);
    },
    resolveContent() {
      const urlParams = new URLSearchParams(window.location.search);
      const urlContent =
        urlParams.get("content") || (this.$route.query.content || "");
      const stateContent = getContentFromState();
      return urlContent || stateContent || getStorage("wechat_content") || "";
    },
    // ---------- 获取用户信息 ----------
    fetchUserInfo() {
      if (!this.content) {
        this.content = this.resolveContent();
      }
      if (!this.content) {
        Toast.fail("页面信息缺失，请重新扫码");
        this.pageLoading = false;
        return;
      }
      setStorage("wechat_content", this.content);

      this.pageLoading = true;
      httpGetQuery("/wechat/wechat/mineInfo", { merId: this.content })
        .then((res) => {
          this.addLog("mineInfo: code=" + res.code);
          this.pageLoading = false;
          if (res.code === "0000") {
            const data = res.data || {};

            this.signingStatus =
              data.signingStatus !== undefined ? data.signingStatus : -1;
            this.signUrl = data.signUrl || null;

            this.form.name = data.name || "";
            this.form.bankName = data.bank || "";
            this.form.bankCard = data.bankCardNo || "";
            this.form.wechat = data.wechatNo || "";
            this.form.phone = data.mobile || "";
            this.form.certNumber = data.idCard || "";
            this.form.idCardFrontPath = data.idCardFrontPath || "";
            this.form.idCardBackPath = data.idCardBackPath || "";

            // =============================================
            // ★ 只用 signingStatus + signUrl 判断 ★
            // =============================================

            // 条件1：signingStatus == 1（已签约）→ 详情，不跳转
            if (this.signingStatus == "1") {
              if (this.isSignCallback) {
                this.isSignCallback = false;
                Toast.success("签约完成！");
                setTimeout(() => {
                  this.$router.push("/square");
                }, 500);
              }
              return;
            }

            // 条件2：signingStatus == 2（解约）
            if (this.signingStatus == "2") {
              if (this.signUrl) {
                this.showRedirect = true;

                this.redirectTip = "检测到您已解约，即将跳转重新签约...";
                setTimeout(() => {
                  window.location.href = this.signUrl;
                }, 1000);
              }
              return;
            }

            // 条件3：signingStatus == 0（未签约）
            if (this.signingStatus == "0") {
              if (this.signUrl) {
                // 有 signUrl → 跳转签约
                this.showRedirect = true;

                this.redirectTip = "检测到您尚未签约，即将跳转签约页面...";
                setTimeout(() => {
                  window.location.href = this.signUrl;
                }, 1000);
              }
              // 无 signUrl → 显示表单
              return;
            }

            // 未知状态 → 显示表单（安全）
          } else {
            Toast(res.message || "获取信息失败，请填写资料");
          }
        })
        .catch((error) => {
          this.pageLoading = false;
          console.error("获取用户信息失败:", error);
          Toast("获取用户信息失败，请稍后重试");
        });
    },

    previewImage(url) {
      if (url) {
        this.$imagePreview([url]);
      }
    },

    // ---------- 提交表单（signingStatus == 0 且 signUrl 无值） ----------
    onSubmit() {
      if (!this.content) {
        this.content = this.resolveContent();
      }
      if (!this.content) {
        Toast.fail("页面信息失效，请重新扫码进入！");
        return;
      }

      if (!this.checkThreeElements()) {
        Toast("请完善姓名、身份证及银行卡信息");
        return;
      }

      if (!this.form.verifyCode) {
        Toast("请填写短信验证码");
        return;
      }

      if (this.frontFileList.length == 0) {
        Toast("请上传身份证人像面");
        return;
      }

      if (this.backFileList.length == 0) {
        Toast("请上传身份证国徽面");
        return;
      }

      this.submitting = true;

      const formData = {
        content: this.content,
        name: this.form.name,
        mobile: this.form.phone,
        vcode: this.form.verifyCode,
        channelType: "2",
        isHmt: "0",
        isSign: "1",
        bankCardNo: this.form.bankCard,
        bank: "",
        wechatNo: this.form.wechat || "",
        idCard: this.form.certNumber,
        alipayNo: "",
        businessLicense: "",
        certNumber: "",
        idCardFrontPath:
          (this.frontFileList[0] && this.frontFileList[0].file) || null,
        idCardBackPath:
          (this.backFileList[0] && this.backFileList[0].file) || null,
      };

      httpPostForm("/wechat/wechat/scanAddUser", formData)
        .then((res) => {
          this.submitting = false;
          if (res.code === "0000") {
            const data = res.data || {};
            const newSignUrl = data.signUrl;
            if (newSignUrl) {
              Toast.success("获取签约链接成功，跳转中...");
              setTimeout(() => {
                window.location.href = newSignUrl;
              }, 1000);
            } else {
              Toast.success("提交成功");
              this.fetchUserInfo();
            }
          } else {
            Toast.fail(res.message || "提交失败");
          }
        })
        .catch((err) => {
          this.submitting = false;
          Toast.fail("提交请求失败，请检查网络");
          console.error("提交失败:", err);
        });
    },

    // ---------- 银行卡校验 ----------
    validateBankCard(val) {
      if (!val) return false;
      const card = val.replace(/\s/g, "");
      if (!/^\d{16,19}$/.test(card)) return false;
      let sum = 0;
      let shouldDouble = false;
      for (let i = card.length - 1; i >= 0; i--) {
        let digit = parseInt(card.charAt(i), 10);
        if (shouldDouble) {
          digit *= 2;
          if (digit > 9) digit -= 9;
        }
        sum += digit;
        shouldDouble = !shouldDouble;
      }
      return sum % 10 === 0;
    },

    checkThreeElements() {
      const { name, certNumber, bankCard } = this.form;
      if (!name || name.trim() === "") return false;
      if (!certNumber || !/^\d{17}[\dXx]$/.test(certNumber)) return false;
      if (!bankCard || !this.validateBankCard(bankCard)) return false;
      return true;
    },

    // ---------- 获取验证码 ----------
    getVerifyCode() {
      if (this.countdown > 0) return;
      const phone = this.form.phone.trim();
      if (!phone) {
        Toast("请先填写手机号码");
        return;
      }
      if (!/^1\d{10}$/.test(phone)) {
        Toast("请输入正确的手机号码");
        return;
      }

      httpPost("/message/messageInfo/addMessageVO", {
        mobiles: phone,
        type: "0",
      })
        .then((data) => {
          if (data.code === "0000") {
            Toast.success("验证码已发送");
            this.countdown = 60;
            if (this.countdownTimer) clearInterval(this.countdownTimer);
            this.countdownTimer = setInterval(() => {
              this.countdown--;
              if (this.countdown <= 0) {
                clearInterval(this.countdownTimer);
                this.countdownTimer = null;
              }
            }, 1000);
          } else {
            Toast.fail(data.message || "发送失败");
          }
        })
        .catch(() => {
          Toast.fail("请求失败，请稍后重试");
        });
    },

    // ---------- 上传图片 ----------
    afterReadFront(file) {
      this.form.idCardFront = file.file;
    },
    deleteFront() {
      this.form.idCardFront = null;
      this.frontFileList = [];
    },
    afterReadBack(file) {
      this.form.idCardBack = file.file;
    },
    deleteBack() {
      this.form.idCardBack = null;
      this.backFileList = [];
    },
  },

  beforeDestroy() {
    if (this.countdownTimer) {
      clearInterval(this.countdownTimer);
      this.countdownTimer = null;
    }
  },
};
</script>

<style scoped>
.page {
  background: #f7f8fa;
  height: 100vh;
  padding-bottom: 100px;
  padding-top: 70px;
  overflow-y: auto;
}
.page-header {
  background: #fff;
  padding: 12px 20px 12px;
  border-bottom: 1px solid #ebedf0;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;
  border-radius: 0 0 24px 24px;
  box-shadow: 0 2px 12px rgba(0, 20, 50, 0.06);
  flex-shrink: 0;
}
.page-header .title {
  font-size: 20px;
  font-weight: 700;
  background: linear-gradient(135deg, #1989fa 0%, #07c160 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  display: inline-block;
}
/* Debug 面板样式（上线前删除） */
.debug-panel {
  background: #fff7e6;
  border-bottom: 1px solid #ffd591;
  padding: 8px 12px;
  font-size: 12px;
  color: #613400;
}
.debug-title {
  cursor: pointer;
  font-weight: 600;
  user-select: none;
}
.debug-content {
  margin-top: 8px;
  line-height: 1.6;
}
.debug-content div {
  word-break: break-all;
}
.debug-logs {
  margin-top: 8px;
  padding-top: 8px;
  border-top: 1px dashed #ffd591;
  font-size: 11px;
  color: #874d00;
}
.loading-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 60vh;
}
.signed-info {
  padding: 16px;
}
.signed-tip {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 20px 0;
  color: #07c160;
  font-size: 16px;
  background: #f0faf0;
  margin: 16px;
  border-radius: 12px;
}
.terminated-tip {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 20px 0;
  color: #ee0a24;
  font-size: 16px;
  background: #fde8e8;
  margin: 16px;
  border-radius: 12px;
}
.redirect-tip-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 20px 0;
  color: #ee0a24;
  font-size: 16px;
  background: #fde8e8;
  margin: 16px;
  border-radius: 12px;
}
.upload-group {
  padding: 12px 16px;
  background: #fff;
  border-bottom: 1px solid #ebedf0;
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.upload-item {
  display: flex;
  flex-direction: column;
}
.upload-inner {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: nowrap;
}
.upload-label {
  font-size: 14px;
  color: #323233;
  white-space: nowrap;
}
.upload-label .required {
  color: #ee0a24;
  margin-left: 2px;
}
.upload-tip {
  font-size: 12px;
  color: #969799;
  margin-top: 0px;
  padding-left: 2px;
}
.contract-wrapper {
  padding: 12px 16px;
  background: #fff;
  border-bottom: 1px solid #ebedf0;
}
.contract-text {
  font-size: 12px;
  color: #969799;
  line-height: 1.5;
}
.protocol-link {
  color: #1989fa;
  text-decoration: none;
  cursor: pointer;
}
.protocol-link:active {
  opacity: 0.6;
}
.submit-wrapper {
  padding: 16px;
  position: relative;
  overflow: visible;
}
.blue-btn {
  background-color: #1989fa !important;
  border-color: #1989fa !important;
  color: #fff !important;
  display: block !important;
  width: 100% !important;
  opacity: 1 !important;
}
.blue-btn[disabled] {
  background-color: #7ab8f7 !important;
  border-color: #7ab8f7 !important;
  opacity: 0.6;
}
.blue-btn[loading] {
  background-color: #1989fa !important;
  border-color: #1989fa !important;
}
.id-card-images {
  background: #fff;
  border-radius: 12px;
  padding: 16px;
  margin: 0 16px 16px;
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
}
.id-card-item {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.id-card-label {
  font-size: 13px;
  color: #666;
}
.empty-text {
  font-size: 13px;
  color: #999;
}
</style>